<template lang="pug">
    div
        // - sub total
        .row
            .col-xs-9
                small.pull-right Subtotal
            .col-xs-3
                small.pull-right {{ pgsql_transaction.sub_total.toFixed(2) }}

        // shell sg capillary
        .row(
            v-if="hasReceiptCapillaryOrderLevel"
            v-for="discount in capillaryDiscounts"
        )
            .col-xs-9
                small.pull-right {{ discount.discountName }}
            .col-xs-3
                small.pull-right {{ discount.discountAppliedAmount.toFixed(2) }}
    
        // - total saving
        .row(v-if="totalSaving > 0.00")
            .col-xs-9
                small.pull-right Total Saving
            .col-xs-3
                small.pull-right {{ totalSaving }}
    
        // - charges
        div.row(v-for="charge in pgsql_transaction.charges")
            div.col-xs-9
                small.pull-right {{ charge.name }}
            div.col-xs-3
                small.pull-right {{ charge.applied_amount.toFixed(2) }}
    
        // - taxes
        div.row(v-for="tax in groupTaxes")
            div.col-xs-9
                small.pull-right {{ tax.taxName }}
            div.col-xs-3
                small.pull-right {{ tax.taxTotal.toFixed(2) }}
    
        // - roudning
        .row(v-if="paymentName.includes('cash')")
            .col-xs-9
                small.pull-right Rounding
            .col-xs-3
                small.pull-right {{ pgsql_transaction.rounding.toFixed(2) }}
    
        // - grand total
        .row.text-md
            div(v-if="isSale || isVoid")
                .col-xs-9
                    small.pull-right.grand-total-label Grand Total
    
            div(v-else-if="isRefund")
                .col-xs-9
                    small.pull-right.grand-total-label Refund Total
    
            .col-xs-3.grand-total-amount
                small.pull-right {{ pgsql_transaction.grand_total.toFixed(2) }}
    
        // - payments
        .row(v-for="payment in pgsql_transaction.payments" v-if="isSale || isVoid")
            div(v-if="payment.source === 'eps_invenco' || payment.source === 'edc'")
                .col-xs-12(v-if="payment.source === 'eps_invenco'")
                    .row
                        .col-xs-9
                            small.pull-right.text-muted {{ payment.terminal_type }} ({{ payment.terminal_id }})
                .col-xs-12
                    .row
                        .col-xs-9
                            small.pull-right {{ payment.source === 'edc' ? payment.name : null }} {{ payment.card.name }} ({{ payment.card.card_pan }})
                        .col-xs-3
                            small.pull-right {{ payment.tender_amount ? payment.tender_amount.toFixed(2) : payment.amount.toFixed(2) }}
    
            div(v-else-if="payment.source === 'ewallet' || payment.source === 'ghl'")
                .col-xs-9
                    small.pull-right {{ payment.name }} {{ payment.ewallet.name }} ({{ payment.ewallet.transaction_id }})
                .col-xs-3
                    small.pull-right {{ payment.tender_amount ? payment.tender_amount.toFixed(2) : payment.amount.toFixed(2) }}
    
            div(v-else-if="payment.source === 'subsidy'")
                .col-xs-9
                    small.pull-right {{ payment.name }} ({{ payment.subsidy.name }})
                .col-xs-3
                    small.pull-right {{ payment.tender_amount ? payment.tender_amount.toFixed(2) : payment.amount.toFixed(2) }}
    
            div(v-else)
                .col-xs-9
                    small.pull-right {{ payment.source === 'shell_app' ? payment.card.name : payment.name }} {{ payment.type === 3 && payment.source !== 'shell_voucher' ? `(${payment.reference_id})` : null }}
                .col-xs-3
                    small.pull-right {{ payment.tender_amount ? payment.tender_amount.toFixed(2) : payment.amount.toFixed(2) }}
    
            .col-xs-9(v-if="payment.source === 'local_account'")
                small.pull-right {{ payment.details.company_name }} ({{ payment.details.authenticator_name }})
    
        // - change
        div.row(v-if="paymentName.includes('cash') && isSale || isVoid")
            div.col-xs-9
                small.pull-right Change
            div.col-xs-3
                small.pull-right {{ change }}
        
        // - overrun
        div.row(v-if="overrun")
            .col-xs-9
                small.pull-right Overrun
            .col-xs-3
                small.pull-right {{ overrun.toFixed(2) }}
    </template>
    
    <script>
import receiptMixin from '../../mixins/receipt';
import { mapGetters } from 'vuex';
import receiptFeatureFlagMixin from './receipt-feature-flag-mixin';

export default {
    mixins: [receiptMixin, receiptFeatureFlagMixin],

    computed: {
        ...mapGetters('transactionPostgres', [
            'pgsql_transaction',
            'totalSaving',
            'paymentName',
            'change',
            'isSale',
            'isRefund',
            'isVoid',
            'groupTaxes',
            'overrun',
            'capillaryDiscounts',
        ]),
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/receipt-postgres/amount.vue